import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const ExpressJS = () => {
  return (
    <StartInterviewLayout type="expressjs"/>
  )
}

export default ExpressJS;